import isEmpty from 'lodash-es/isEmpty';

const HOTEL_CODE = 'HOTEL_CODE';
const AIR_CODE = 'AIR_CODE';
const NULL_CODE = 'NULL';

const REGEX = /(HOTEL_CODE:)([-\w]+)(\:\|\:)(AIR_CODE:)([-\w]+)(\:)/;

export function generateAirPackageReservationCode(airCode: string, hotelCode: string): string {
  if (hotelCode && airCode) {
    return `${HOTEL_CODE}:${hotelCode}:|:${AIR_CODE}:${airCode}:`;
  } else if (airCode && isEmpty(hotelCode)) {
    return `${HOTEL_CODE}:${NULL_CODE}:|:${AIR_CODE}:${airCode}:`;
  } else if (hotelCode && isEmpty(airCode)) {
    return `${HOTEL_CODE}:${hotelCode}:|:${AIR_CODE}:${NULL_CODE}:`;
  } else return '';
}

export function getAirCodeByPackageAirCode(airPackageCode: string): string {
  const parts = matchAirPackageReservationCode(airPackageCode);
  return parts?.length && parts?.[5] !== NULL_CODE ? parts[5] : null;
}

export function getHotelCodeByPackageAirCode(airPackageCode: string): string {
  const parts = matchAirPackageReservationCode(airPackageCode);
  return parts?.length && parts?.[2] !== NULL_CODE ? parts[2] : null;
}

function matchAirPackageReservationCode(airPackageCode: string): string[] {
  return airPackageCode ? airPackageCode.match(REGEX) : [];
}
